import * as React from 'react'
import * as _ from 'lodash'
import {  parseFloatTotal, workerHasPermission } from '../Job'
import { getCurrentUserId } from '../../../../utils/currentUser';
import { InvoiceWorkerT } from '../../../../types/JobWorker';

import { Form, Table } from 'react-bootstrap';
import { css } from 'glamor';
import { formatDate } from '../../../../utils/utilsT';
import { JobT } from '../../../../types/Job';



interface WorkerFinancialTabProps {
    job: JobT
}


interface RowFlexProps {
    childern?: React.ReactNode
    className?: string
}

const RowFlex: React.FC<RowFlexProps> = ({ children, className }): JSX.Element => {
    return (
        <div className={`d-flex flex-column w-100 p-2 ${className ? className : ''} `}>
            {children}
        </div>
    )
}


const RenderColumns: React.FunctionComponent<{
    columns: Array<string>
    customRenderColumn?(column: string, index: number): JSX.Element
}> = ({ columns, customRenderColumn }) => {
    return (
        <thead>
            <tr>
                {columns.map((item, index) => {
                    if (customRenderColumn) {
                        return <th key={index}>{customRenderColumn(item, index)}</th>
                    }
                    return (
                        <th key={index}>{item}</th>
                    )
                })}
            </tr>
        </thead>
    )
}

const WorkerFinancialTab: React.FC<WorkerFinancialTabProps> = ({ job }) => {
    const [itemsInvoice, setItemsInvoice] = React.useState([]);
    const currentUserId = getCurrentUserId()
    React.useEffect(() => {
        setItemsInvoice(getItemsFromCrew(job))
    }, [job]);


    /**
     * 
     * @param job 
     */
    const getItemsFromCrew = (job): Array<InvoiceWorkerT> => {
        const crew = job.crew && _.isArray(job.crew) ? job.crew : []
        const find = crew.find((x) => x.id == currentUserId)
        if (find && _.has(find, 'invoice')) {
            return find.invoice
        }
        return []
    }

    const sumTotal = (invoiceClone: Array<InvoiceWorkerT>): number => {
        if (invoiceClone.length == 0) return 0
        else {
            let lineItemSum = invoiceClone.shift()
            let total = lineItemSum.total ? lineItemSum.total : 0
            return Number(parseFloat(`${total}`)) + Number(sumTotal(invoiceClone))
        }
    }
    console.log("itemsInvoice", itemsInvoice)
    return (
        <div>
            <h1>Pay Summary</h1>

            <Table responsive striped className="mt-2 mb-2" >
                {<RenderColumns columns={['Date', 'Rate', 'Unites', 'Total', '']} />}
                <tbody>
                    {_.isArray(itemsInvoice) && itemsInvoice.map((item: InvoiceWorkerT, index) => {
                        return (
                            <tr key={index}>
                                <td> <span>{formatDate(item.date, 'MMMM DD, YYYY')}</span></td>
                                <td>   <span>${parseFloatTotal(item.rate)}/hour</span></td>
                                <td>   <span>{parseFloatTotal(item.units)} hours</span></td>
                                <td>   <span>${parseFloatTotal(item.total)}</span></td>
                                <td><span style={{ fontWeight: 'bold' }} className={` ${item.paid && item.paid == true ? 'text-success' : 'text-danger'}`}> {item.paid && item.paid == true ? 'Paid' : 'Unpaid'}</span></td>
                            </tr>
                        )
                    })}
                    <tr>
                        <td colSpan={4}></td>

                        <td>  <div className={`d-flex flex-column     `}>
                            <Form.Label style={{ fontWeight: 'bold' }}>Total</Form.Label>
                            <span style={{ fontWeight: 'bold' }} >${parseFloatTotal(sumTotal(itemsInvoice))} </span>
                        </div></td>
                    </tr>
                </tbody>

            </Table>
            {/* <p>Line Item Invoice Items</p> */}

          
        </div>
    )
}

export default WorkerFinancialTab